// Libs
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
// Images
import imgNewsletter2549 from 'url:../../../../../resource/images/newsletter_2549.png';
// Lang
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2549
const Sp2549Newsletter021225 = ({ params }) => {
    const { t: translate } = useTranslation(nsNewsletter);
    const elements = { 1: <b />, 2: <b /> };

    return (
        <div className='space-y-4'>
            <div>
                <div className='space-y-4'>
                    <div className='space-y-4'>
                        <p className='font-semibold text-lg text-primary'>
                            {translate('editions.sp2549.section_1.title')}
                        </p>
                        <p>
                            <Trans t={translate} i18nKey='editions.sp2549.section_1.p1' components={{ 1: <b /> }} />
                        </p>
                        <p>{translate('editions.sp2549.section_1.intro')}</p>
                        <ul className='list-disc ml-8'>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_1.li1' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_1.li2' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_1.li3' components={{ 1: <b /> }} /></li>
                        </ul>
                        <p>{translate('editions.sp2549.section_1.p2')}</p>
                    </div>
                    <hr />
                    <div className='space-y-4'>
                        <p className='font-semibold text-lg text-primary'>
                            {translate('editions.sp2549.section_2.title')}
                        </p>
                        <p>
                            <Trans t={translate} i18nKey='editions.sp2549.section_2.p1' components={elements} />
                        </p>
                        <p>
                            <Trans t={translate} i18nKey='editions.sp2549.section_2.p2' components={{ 1: <b /> }} />
                        </p>
                        <p><b>{translate('editions.sp2549.section_2.how')}</b></p>
                        <ol className='list-decimal ml-8'>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_2.ol1' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_2.ol2' components={{ 1: <b /> }} /></li>
                            <li>
                                <Trans t={translate} i18nKey='editions.sp2549.section_2.ol3' components={elements} />
                                <ul className='list-disc ml-8'>
                                    <li><Trans t={translate} i18nKey='editions.sp2549.section_2.nested1' components={{ 1: <b /> }} /></li>
                                    <li><Trans t={translate} i18nKey='editions.sp2549.section_2.nested2' components={{ 1: <b /> }} /></li>
                                    <li><Trans t={translate} i18nKey='editions.sp2549.section_2.nested3' components={{ 1: <b /> }} /></li>
                                </ul>
                            </li>
                        </ol>
                        <p></p>
                        <b>{translate('editions.sp2549.section_2.important')}</b>
                        <p></p>
                        <ul className='list-disc ml-8'>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_2.ul1' components={{ 1: <b /> }} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_2.ul2' components={elements} /></li>
                            <li><Trans t={translate} i18nKey='editions.sp2549.section_2.ul3' components={{ 1: <b /> }} /></li>
                        </ul>
                        <p></p>
                    </div>
                    <img onLoad={() => params.handleImageLoad()}
                        src={imgNewsletter2549} /><br /><br />
                </div>
            </div>
            <br />
        </div >
    );
};

Sp2549Newsletter021225.propTypes = {
    params: PropTypes.shape({
        handleImageLoad: PropTypes.func.isRequired
    }).isRequired
};

export default Sp2549Newsletter021225;
